export const REQUIRED_ERROR_MESSAGE = "This field is required";
